import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {ApplicationCategoryCard} from '../../../components/common/applications/applicationCategoryCard';
import {useLinkNavigation} from '../../../components/common/navigation/useLinkNavigation';
import {
  renderIntegrationTypeCategoryDescription,
  renderIntegrationTypeCategoryName,
} from '../../../helpers/integrationTypesHelpers';
import {IntegrationTypeCategoriesEnum} from '../../../models/api/integrationTypesModel';
import {buildSettingsAppsCategoryUrl} from '../../../models/url/settingsUrlHelpers';
import {InterfaceEventsEnum, trackInterfaceEvent} from '../../../services/tracking';
import {AppsGrid} from '../layout/appsGrid';

/*
 * Constants.
 */

const orderOfCategoriesToRender = [
  IntegrationTypeCategoriesEnum.ANALYTICS_REPORTING,
  IntegrationTypeCategoriesEnum.BILLING_INVOICING,
  IntegrationTypeCategoriesEnum.BOTS_WORKFLOW_AUTOMATION,
  IntegrationTypeCategoriesEnum.CHANNELS_MESSAGING,
  IntegrationTypeCategoriesEnum.CRM_ECOMMERCE,
  IntegrationTypeCategoriesEnum.DATA_PRIVACY,
  IntegrationTypeCategoriesEnum.DATA_SYNC_ENRICHMENT,
  IntegrationTypeCategoriesEnum.KNOWLEDGE_CONTENT,
  IntegrationTypeCategoriesEnum.PRODUCTIVITY,
  IntegrationTypeCategoriesEnum.PROJECT_MANAGEMENT_ISSUE_TRACKING,
  IntegrationTypeCategoriesEnum.SURVEYS_FEEDBACK,
  IntegrationTypeCategoriesEnum.VOICE_TELEPHONY,
];

/*
 * Component.
 */

export const SettingsAppsCategoriesPage: FC = () => {
  const {navigateToLink} = useLinkNavigation();

  return (
    <AppsGrid>
      {orderOfCategoriesToRender.map((category) => (
        <ApplicationCategoryCard
          key={category}
          title={renderIntegrationTypeCategoryName(category)}
          description={renderIntegrationTypeCategoryDescription(category)}
        >
          <Button
            variant={ButtonVariantsEnum.PRIMARY}
            onClick={() => {
              trackInterfaceEvent(InterfaceEventsEnum.APPS_SETTINGS_CATEGORY_CLICK, {
                id: 'see-apps',
                category,
              });
              navigateToLink(buildSettingsAppsCategoryUrl(category));
            }}
          >
            <Trans id="settings-apps-category-category-card-button">See apps</Trans>
          </Button>
        </ApplicationCategoryCard>
      ))}
    </AppsGrid>
  );
};
